<mat-dialog-content class="mat-typography">
    <div class="example-form" *ngIf="data">
        <mat-form-field class="example-full-width">
            <mat-label>Description</mat-label>
            <input matInput placeholder="Description" [(ngModel)]="data.description"  [disabled]="data.sourceId != -1">
        </mat-form-field>
        <mat-form-field class="example-full-width">
            <mat-label>Language Id</mat-label>
            <mat-select [(ngModel)]="data.langId" [compareWith]="customCompare">
                <mat-option>None</mat-option>
                <mat-option value=0>0</mat-option>
                <mat-option value=1>1</mat-option>
                <mat-option value=2>2</mat-option>
                <mat-option value=3>3</mat-option>
                <mat-option value=4>4</mat-option>
                <mat-option value=5>5</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="example-full-width">
            <mat-label>Language Group</mat-label>
            <mat-select [(ngModel)]="data.langGroup" [compareWith]="customCompare">
                <mat-option>None</mat-option>
                <mat-option value=0>0</mat-option>
                <mat-option value=1>1</mat-option>
                <mat-option value=2>2</mat-option>
                <mat-option value=3>3</mat-option>
                <mat-option value=4>4</mat-option>
                <mat-option value=5>5</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-checkbox class="example-margin" [(ngModel)]="data.inactive">Is Inactive</mat-checkbox>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
        <mat-icon>cancel</mat-icon>Cancel
    </button>
    <button mat-raised-button color="accent" [mat-dialog-close]="false" cdkFocusInitial (click)="delete()">
        <mat-icon>delete_outline</mat-icon>Delete
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="false" cdkFocusInitial (click)="save()">
        <mat-icon>save</mat-icon>Save
    </button>
</mat-dialog-actions>